import { Exclude } from "class-transformer";
import { Column, Entity, JoinColumn, ManyToOne } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { Coupon } from "./coupon.entity";
import { QuestionHeader } from "./question-header.entity";
import { Shop } from "./shop.entity";

@Entity()
export class ShopToken extends CommonColumns {

  @Exclude()
  @Column({ unique: true, length: 20, })
  token: string;

  @Exclude()
  @Column()
  memo1: string;

  @Exclude()
  @Column()
  memo2: string;

  @Column()
  disabled: boolean;

  @ManyToOne(() => Shop, shop => shop.tokens, { nullable: true, })
  @JoinColumn({ name: 'shop_id', referencedColumnName: 'id', })
  shop: Shop|null;

  @Column({ name: 'shop_id', nullable: true, })
  shop_id: number|null;

  @ManyToOne(
    () => QuestionHeader,
    questionHeader => questionHeader.shopTokens,
    {
      nullable: true,
    },
  )
  @JoinColumn({ name: 'question_header_id', referencedColumnName: 'id', })
  questionHeader: QuestionHeader|null;

  @Column({ name: 'question_header_id', nullable: true, })
  question_header_id: number|null;

  @ManyToOne(() => Coupon, { nullable: true, })
  @JoinColumn({ name: 'coupon_id', referencedColumnName: 'id', })
  coupon: Coupon|null;

  @Column({ name: 'coupon_id', nullable: true, })
  couponId: number|null;

  constructor(props: TShopToken) {
    super();
    Object.assign(this, props);
  }
}

export declare type TShopToken = Omit<ShopToken, 'dummy-no-such-field'>;
export interface IShopToken extends TShopToken {};
